const MAX_ENTRIES = 1000;

const levels = ["log", "info", "warn", "error", "debug"];

let buffer = [];
let installed = false;

const serializeArg = (arg) => {
  if (arg instanceof Error) {
    return `${arg.name}: ${arg.message}${arg.stack ? `\n${arg.stack}` : ""}`;
  }

  if (typeof arg === "string") {
    return arg;
  }

  try {
    return JSON.stringify(arg);
  } catch {
    return String(arg);
  }
};

const pushEntry = (level, args) => {
  buffer.push({
    ts: new Date().toISOString(),
    level,
    message: args.map(serializeArg).join(" "),
  });

  if (buffer.length > MAX_ENTRIES) {
    buffer = buffer.slice(buffer.length - MAX_ENTRIES);
  }
};

export const installConsoleBuffer = () => {
  if (installed || typeof window === "undefined") {
    return;
  }

  installed = true;

  levels.forEach((level) => {
    const original = console[level]?.bind(console);
    if (!original) {
      return;
    }

    console[level] = (...args) => {
      try {
        pushEntry(level, args);
      } catch {
      }
      original(...args);
    };
  });

  window.addEventListener("error", (event) => {
    pushEntry("error", [
      event.message,
      event.filename && `${event.filename}:${event.lineno}:${event.colno}`,
      event.error,
    ].filter(Boolean));
  });

  window.addEventListener("unhandledrejection", (event) => {
    pushEntry("error", ["Unhandled rejection", event.reason]);
  });
};

export const getConsoleLogText = () =>
  buffer
    .map((entry) => `[${entry.ts}] [${entry.level.toUpperCase()}] ${entry.message}`)
    .join("\n");

export const getConsoleLogBlob = () =>
  new Blob([getConsoleLogText()], { type: "text/plain" });
